import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import './Page1.css';
import { HomeContext } from '../Context/HomeContext';
import { FaCalendarAlt, FaEye } from 'react-icons/fa';

const Page1 = () => {
  const { homeData, loading } = useContext(HomeContext);
  const blogs = homeData?.recentBlogs?.slice(0, 7) || [];

  const leftBlogs = blogs.slice(0, 4);
  const centerBlog = blogs[4];
  const rightBlogs = blogs.slice(5, 9);

  // 🔄 Loading state
  if (loading || blogs.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading Section...</div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row">
      <h3 className="fw-bold mb-4 border-bottom pb-2">Recent Blogs</h3>

        {/* LEFT COLUMN */}
        <div className="col-lg-3 col-md-6 mb-4 d-flex flex-column gap-3">
          {leftBlogs.map((item) => (
            <NavLink to={`/blog/${item.slug}`} key={item.id} className="text-decoration-none text-dark">
              <div className="d-flex align-items-start blog-thumb-hover">
                <img
                  src={`https://api.funfillia.com/${item.image_400x300}`}
                  alt="thumb"
                  width="60"
                  height="60"
                  className="me-2 rounded thumb-effect"
                />
                <div>
                  <p className="mb-1 fw-semibold">{item.title}</p>
                  <small className="text-muted">
                    <FaCalendarAlt/> {new Date(item.published_at).toLocaleDateString()}
                  </small>
                </div>
              </div>
            </NavLink>
          ))}
        </div>

        {/* CENTER FEATURE */}
        <div className="col-lg-6 col-md-12 mb-4">
          {centerBlog && (
            <NavLink to={`/blog/${centerBlog.slug}`} className="text-decoration-none text-dark">
              <div
                className="position-relative feature-image-hover"
                style={{
                  backgroundImage: `url(https://api.funfillia.com/${centerBlog.image_500x500})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '330px',
                  borderRadius: '10px',
                }}
              >
                <div className="position-absolute bottom-0 start-0 bg-dark bg-opacity-50 text-white p-3 w-100 feature-overlay">
                  <h4 className="fw-bold">{centerBlog.title}</h4>
                  <small>
                    <FaCalendarAlt/> {new Date(centerBlog.published_at).toLocaleDateString()} <FaEye/> {centerBlog.views_count} views
                  </small>
                </div>
              </div>
            </NavLink>
          )}
        </div>

        {/* RIGHT COLUMN */}
        <div className="col-lg-3 col-md-6 mb-4 d-flex flex-column gap-3">
          {rightBlogs.map((item) => (
            <NavLink to={`/blog/${item.slug}`} key={item.id} className="text-decoration-none text-dark">
              <div className="d-flex align-items-start blog-thumb-hover">
                <div className="me-2">
                  <p className="mb-1 fw-semibold">{item.title}</p>
                  <small className="text-muted">
                    <FaCalendarAlt/> {new Date(item.published_at).toLocaleDateString()}
                  </small>
                </div>
                <img
                  src={`https://api.funfillia.com/${item.image_400x300}`}
                  alt="thumb"
                  width="60"
                  height="60"
                  className="rounded thumb-effect"
                />
              </div>
            </NavLink>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Page1;
